export const API_PATH_ApiTrafficStudiesVehiclesCountEnvironmentalDataSearchGet = '/services/traffic-studies/apiTrafficStudiesVehiclesCountEnvironmentalDataSearchGet';
